import { useEffect, useState } from 'react';
import authService from '../../services/authService';

/**
 * Composant invisible qui gère la persistance de session
 * Ce composant doit être inclus une seule fois dans l'application, idéalement dans App.jsx
 */
const SessionManager = () => {
  const [sessionRestored, setSessionRestored] = useState(false);

  useEffect(() => {
    // Tenter de restaurer la session au chargement de l'application
    const restoreUserSession = () => {
      const restored = authService.restoreSession();
      setSessionRestored(restored);
      console.log(restored ? 'Session restaurée avec succès' : 'Aucune session à restaurer');
    };

    // Écouter les changements de localStorage pour gérer la synchronisation entre onglets
    const handleStorageChange = (event) => {
      if (event.key === 'token' || event.key === 'userInfo') {
        restoreUserSession();
      }
    };

    restoreUserSession();
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Ce composant ne rend rien, il ne fait que gérer la session
  return null;
};

export default SessionManager;
